import 'lib/findDOMNodeShim';
import {hydrate} from 'lib/htmlIsland/hydrate';
import islands from 'lib/htmlIsland/unit/islands.json';
import {BINDINGS} from 'lib/htmlIsland/unit/bindings';

// Entry point: hydrate the TDS2 islands that can appear in unit content. The
// registry lives in lib/htmlIsland/unit/; docs/ui-architecture.md documents the
// island convention (single source of truth, drift guard, how to add one).
hydrate(islands, BINDINGS);
